import { BlogPostPage } from "@web/pages/blog/BlogPostPage";
import { SpacedRepetitionPage } from "@web/pages/spaced-repetition/SpacedRepetitionPage";
import { PostDataWithHtml } from "@web/types/blog/PostDataWithHtml";
import { getAllPostIds } from "@web/utils/blog/getAllPostIds";
import { getPostData } from "@web/utils/blog/getPostData";
import { GetStaticPaths, GetStaticProps } from "next";
import Head from "next/head";

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = getAllPostIds();
  return {
    fallback: false,
    paths,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const postData = await getPostData(params?.id as string);
  return {
    props: {
      postData,
    },
  };
};

type Props = {
  postData: PostDataWithHtml;
};

export default function Post({ postData }: Props) {
  return (
    <>
      <Head>
        <title>{`Harken | ${postData.title}`}</title>
        <meta name="description" content={postData.summary} />
      </Head>
      {postData.id === "spaced-repetition" ? (
        <SpacedRepetitionPage />
      ) : (
        <BlogPostPage postData={postData} />
      )}
    </>
  );
}
